import * as React from 'react';
import * as classNames from 'classnames';

interface IPercentageBarProps {
  color?: 'green';
  percentage?: number;
  animate?: boolean;
}

export default function PercentageBar({
  color,
  percentage,
  animate,
}: IPercentageBarProps) {
  const classes = classNames(
    'percentage-bar',
    { 'percentage-bar--green': color === 'green' },
    { 'percentage-bar--animated': animate },
  );

  return (
    <div className={classes}>
      <div
        className="percentage-bar__progress"
        style={{ width: `${percentage}%` }}
      />
    </div>
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/src/components/percentage_bar.tsx